import { FormattedMessage, useIntl } from 'react-intl';
import { Spacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { sortProvidersAlphabetically } from '../../../utilities/provider-utils';
import { Header } from '../../../components/organisms/Header/Header';
import { ProviderEntity } from '../../../models/provider';
import { H1 } from '../../../components/atoms/Heading/Heading';
import { ContentBody } from '../../../components/atoms/ContentBody/ContentBody';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { SelectableOption } from '../../../components/screens/molecules/SelectableOption/SelectableOption';
import { Subtitle } from '../../../components/atoms/Subtitle/Subtitle';
import { PageView } from '../../../models/analytics';

import {
  providerSignInMethodDescription,
  providerSignInMethodIcon,
} from '../CredentialsTypePicker/CredentialsTypePicker';
import { messages } from './messages';

type OnProviderItemClick = ({ providerName }: { providerName: string }) => void;

type DisplayDescriptionPickerProps = {
  onBack: () => void;
  providers: ProviderEntity[];
  onProviderItemClick: OnProviderItemClick;
};

export const DisplayDescriptionPicker = ({
  onBack,
  providers,
  onProviderItemClick,
}: DisplayDescriptionPickerProps) => {
  const intl = useIntl();

  const alphabeticallySortedProviders = sortProvidersAlphabetically({
    providers,
    sortingKey: 'displayDescription',
  });

  return (
    <ScreenWrapper>
      <Header onBack={onBack} pageView={PageView.DISPLAY_DESCRIPTION_SELECTION_SCREEN} />
      <ContentBody>
        <H1>
          <FormattedMessage {...messages.signInMethod} />
        </H1>
        <Subtitle>
          <FormattedMessage {...messages.chooseConnectionMethod} />
        </Subtitle>
        <Spacer size="normal" />
        {alphabeticallySortedProviders.map((provider) => {
          return (
            <SelectableOption
              key={provider.name}
              Icon={providerSignInMethodIcon(provider)}
              text={providerSignInMethodDescription(intl, provider)}
              onClick={() => {
                onProviderItemClick({ providerName: provider.name });
              }}
            />
          );
        })}
      </ContentBody>
    </ScreenWrapper>
  );
};
